"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const functions_2 = require("@/order/payment_detail/functions");
function default_1({ open, closeDialog, setPaymentDetail, isSecondPayment, }) {
    const pendingRef = (0, react_1.useRef)(false);
    const safeCloseDialog = () => {
        !pendingRef.current && closeDialog();
    };
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog: safeCloseDialog });
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const onChangePayMethodClick = () => __awaiter(this, void 0, void 0, function* () {
        if (!pendingRef.current) {
            pendingRef.current = true;
            setIsPending(true);
            const onError = () => {
                closeDialog();
                (0, functions_1.delay)(500).then(() => {
                    pendingRef.current = false;
                    setIsPending(false);
                });
            };
            yield (0, functions_2.changePaymentMethod)({
                isSecondPayment,
                setPaymentDetail,
                onError,
            });
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, onClose: safeCloseDialog, slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-60)' } } }, PaperProps: {
            sx: {
                width: '374px',
                padding: '14px',
                borderRadius: '16px',
                margin: '0 20px',
            },
        } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '16px' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-60", css: { minHeight: '52px' } }, { children: t('이미 입금하셨다면 [ 취소 ]를 눌러주세요!') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                        display: 'flex',
                        columnGap: '8px',
                        '> button': { width: '100%', height: '40px', padding: '0 16px', borderRadius: '8px' },
                    } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: safeCloseDialog, sx: {
                                border: '1px solid var(--gray-10)',
                                bgcolor: 'var(--white) !important',
                                color: 'var(--gray-80)',
                            } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2" }, { children: t('취소') })) })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onChangePayMethodClick, sx: {
                                alignSelf: 'flex-end',
                                bgcolor: 'var(--primary-main) !important',
                                color: 'var(--white)',
                            } }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, color: "inherit", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('결제수단 변경') }))) }))] }))] })) })));
}
exports.default = default_1;
